import { StyleSheet } from "react-native"
import { colors, typography } from "theme"

export const style = StyleSheet.create({
  buttonContainer: { alignItems: "center", flex: 1, justifyContent: "flex-end", marginBottom: 30 },

  container: { height: "100%", padding: 10, paddingTop: 40 },
  inputContainer: { alignSelf: "center", marginTop: 20 },
  inputStyle: {
    height: 50,
    paddingLeft: 10,
    paddingVertical: 10,
    width: "100%",
  },
  loginButton: { marginBottom: 20 },
  logoImage: {
    flex: 1,
    height: null,
    margin: 20,
    resizeMode: "contain",
    width: null,
  },
  mv30: { marginVertical: 30 },

  dropdownContainer: { marginTop: 20 },

  title2: {
    fontFamily: typography.primary.normal,
    fontSize: 12,
    marginBottom: 6,
    paddingLeft: 4,
  },
  titleContainer: {
    backgroundColor: colors.white,
    left: 20,
    opacity: 1,
    position: "absolute",
    top: 2,
    zIndex: 9999,
  },
  titleText: { fontFamily: typography.primary.normal, fontSize: 23, marginBottom: 10 },
  dropdown: {
    backgroundColor: colors.inputFieldBackground,
    borderColor: colors.inputFieldBorder,
    borderRadius: 999,
    borderWidth: 1,
    flexDirection: "row",
    justifyContent: "center",
    marginBottom: 6,
    marginTop: 10,
    minHeight: 50,
    paddingRight: 10,
  },
})
